import { z } from 'zod';

import { TypeHeader } from '../models/contentful-generated';
import { ContentfulSysSchema } from './contentful-sys.validator';
import { NavigationDropdownEntrySchema } from './navigation-dropdown.validator';
import { NavigationItemEntrySchema } from './navigation-item.validator';

export const HeaderEntrySchema = z.object({
  sys: ContentfulSysSchema,
  fields: z.looseObject({
    internalName: z.string(),
    navigationItems: z.array(z.union([NavigationDropdownEntrySchema, NavigationItemEntrySchema])),
    alignment: z.enum(['Left', 'Right']).optional().nullable()
  }),
  metadata: z
    .object({
      tags: z.array(z.any()).optional().nullable()
    })
    .optional()
    .nullable()
});

export function validateHeaderEntry(data: TypeHeader) {
  return HeaderEntrySchema.safeParse(data);
}

/**
 * Returns validation result.
 *
 * @param data
 */
export function validateHeaderEntries(data: TypeHeader[]) {
  return z.array(HeaderEntrySchema).safeParse(data);
}

/**
 * Returns valid entries only. In most cases, this is preferred,
 * It allows us to still show some entries instead of showing nothing when only a single entry is invalid.
 *
 * @param data
 */
export function validateAndFilterHeaderEntries(data: TypeHeader[]) {
  if (!data) return [];

  return data.reduce((acc: TypeHeader[], entry) => {
    const validationResult = validateHeaderEntry(entry);
    if (validationResult.success) {
      acc.push(validationResult.data as unknown as TypeHeader);
    } else {
      console.warn(
        `Validation failed for header entry with id: '${entry?.sys?.id}'. It will be filtered out. Error: ${validationResult.error.message}`
      );
    }
    return acc;
  }, []);
}
